import React from "react";
import { CustomBadge } from "../../../../components/Badge";
import { Flex, Text } from "@fluentui/react-northstar";
import styled from "styled-components";
import { format_number } from "../../../../constants/maths";

const CardRecapYear = ({
    title,
    description,
    added_value,
    value_after,
    is_from_timesheet,
}) => {
    const bg_color = is_from_timesheet
        ? added_value > 0
            ? "#E7F2DA"
            : "#FCF4F6"
        : "#FBF6D9";
    const color = is_from_timesheet
        ? added_value > 0
            ? "#13A10E"
            : "#C4314B"
        : "#242424";
    const border_color = is_from_timesheet
        ? added_value > 0
            ? "#BDDA9B"
            : "#F3D6D8"
        : "transparent";

    return (
        <Card column>
            <Flex>
                <CustomBadge
                    label={title}
                    rectangular
                    bg="#EBEBEB"
                    color="#242424"
                />
            </Flex>
            <Flex>
                <Text truncated content={description} />
            </Flex>
            <Flex vAlign="center" space="between" fill>
                <Flex>
                    <CustomBadge
                        label={format_number(added_value) + " h"}
                        bg={bg_color}
                        color={color}
                        rectangular
                        style={{
                            border: `1px solid ${border_color}`,
                        }}
                    />
                </Flex>
                <Flex>
                    <Text
                        color="brand"
                        weight="semibold"
                        content={format_number(value_after) + " h"}
                    />
                </Flex>
            </Flex>
        </Card>
    );
};

export default CardRecapYear;

const Card = styled(Flex)`
    display: flex;
    flex: 1;
    max-width: 176px;
    min-width: 176px;
    padding: 12px;
    gap: 8px;

    border-radius: 4px;
    background: var(--Light-theme-Rest-Background-Default-Background, #fff);

    /* shadow-4 */
    box-shadow: 0px 0.3px 0.9px 0px rgba(0, 0, 0, 0.07),
        0px 1.6px 3.6px 0px rgba(0, 0, 0, 0.11);
`;
